import axios from "axios";

//debugger
const api = axios.create({
  baseURL: "https://api.bi.playtelematics.com",
  // baseURL: "http://localhost:8085",
  // baseURL: "https://api.guidz.com.br",
  // baseURL: "https://api-guidz-dot-absolute-router-392014.de.r.appspot.com",
});

api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("@PLAY_TELEMATICS_TOKEN:");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
